/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { createContext } from 'react'
import type { ImperativeSubmit } from './useActionForm'

const initialState = {
  setBusy: (_: boolean) => {},
  submit: (() => {
    throw new Error('Sumbission failed')
  }) as ImperativeSubmit<any, any>,
  defaultValues: undefined as Record<string, string> | undefined,
}

const ActionFormContext = createContext(initialState)
export default ActionFormContext
